import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

const today = () => new Date().toISOString().slice(0, 10);
const fmt = (d) => (d && d.length >= 10 ? `${d.slice(8, 10)}/${d.slice(5, 7)}` : "");

// Démarre une séance enregistrée : séance créée (ou réutilisée) puis enregistrement global lié à cette séance, puis ouverture de l'onglet Transcription.
export const startRecordedSession = async ({ recording, navigate, patientId, patientName, appointmentId, sessionType, existing, language }) => {
  if (recording.session) {
    toast.error(`Un enregistrement est déjà en cours (${recording.session.label}). Arrêtez-le avant d'en démarrer un autre.`);
    return null;
  }
  let report = existing || null;
  try {
    if (!report) {
      const r = appointmentId
        ? await axios.post(`${API}/appointments/${appointmentId}/create-report`, {}, { withCredentials: true })
        : await axios.post(`${API}/session-reports`, { patient_id: patientId, session_type: sessionType || "suivi_tcc", session_date: today(), fields: {} }, { withCredentials: true });
      report = r.data;
    }
  } catch (e) {
    toast.error(e.response?.data?.detail || "Impossible de créer la séance");
    return null;
  }
  const first = (patientName || report.patient_name || "Patient").split(" ")[0];
  const meta = { reportId: report.report_id, patientId: report.patient_id, label: `${first} · séance du ${fmt(report.session_date)}`, language: report.language || language || "fr", speakers: report.session_type === "therapie_couple" ? 3 : 2 };
  try {
    await recording.start(meta);
    toast.success("Enregistrement démarré — à l'arrêt, la transcription sera ajoutée automatiquement à cette séance.");
  } catch (e) {
    toast.error(e.message === "Un enregistrement est déjà en cours" ? e.message : "Impossible d'accéder au microphone. Vérifiez les permissions, puis relancez depuis l'onglet Transcription.", { duration: 8000 });
  }
  navigate(`/therapist/patients/${report.patient_id}?session=${report.report_id}&tab=transcript`);
  return report;
};
